module.exports = __webpack_public_path__ + "img/how_we_build_brands_illustration.4b24aaf2.svg";